// Modern Chromium-based Edge includes "Edg/" (not "Edge/") in the user agent.
export const isEdgeBrowser = (): boolean => typeof navigator !== 'undefined' && /Edg\//.test(navigator.userAgent);
